export const API_URL = process.env.VUE_APP_BASE_API
export default API_URL
